import dayjs from "dayjs";

export const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

export const formatOrderStatus = (input) => {
    return input
        ?.toLowerCase() 
        ?.split('_') 
        ?.map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        ?.join(' ');
}

export const formatUnitCount = (count, singular, plural = `${singular}s`) => {
    const numericCount = Number(count || 0);
    return `${numericCount} ${numericCount === 1 ? singular : plural}`;
}

export const formatSlideCount = (slides) => formatUnitCount(slides, "slide");

export const formatPagesSlidesRequirement = (pages, slides) => {
    const pageCount = Number(pages || 0);
    const slideCount = Number(slides || 0);

    if (pageCount <= 0 && slideCount > 0) {
        return {
            label: "Slides",
            value: formatSlideCount(slideCount),
            hasSlides: true,
        };
    }

    return {
        label: slideCount > 0 ? "Pages/Slides" : "Pages",
        value: slideCount > 0 ? `${formatUnitCount(pageCount, "page")} / ${formatSlideCount(slideCount)}` : `${pageCount}`,
        hasSlides: slideCount > 0,
    };
}

export const getUptoFourteenDaysLater = (date) => {
    const fourteenDaysLater = new Date(date);
    fourteenDaysLater.setDate(fourteenDaysLater.getDate() + 14);
    return fourteenDaysLater;
}

export const calculateLocalDeadline = (deadline) => {

    // Extract the number and unit (days or hours) from the deadline string
    const [value, unit] = deadline.split(" ");
    const amount = parseInt(value);

    let newDate;

    if (unit === "days") {
        newDate = dayjs().add(amount, "day");
    } else if (unit === "hours") {
        newDate = dayjs().add(amount, "hour");
    }

    return newDate?.format("dddd, MMMM D, YYYY h:mm A");
}

export const calculateLocalDeadlineOptionLabel = (deadline) => {

    // Extract the number and unit (days or hours) from the deadline string
    const [value, unit] = deadline.split(" ");
    const amount = parseInt(value);

    let newDate;

    if (unit === "days") {
        newDate = dayjs().add(amount, "day");
    } else if (unit === "hours") {
        newDate = dayjs().add(amount, "hour");
    }

    return newDate?.format("MMMM D, YYYY h:mm A");
}
